// Formatting helpers. Backend timestamps are MICROSECONDS since epoch (FACTS PACK §2).

/** Microsecond epoch → local date-time string (zh-Hant locale default). '—' for empty. */
export function formatTimestampUs(us: number | string | null | undefined, opts?: Intl.DateTimeFormatOptions): string {
  if (us === null || us === undefined || us === '') return '—';
  const n = typeof us === 'string' ? Number(us) : us;
  if (!Number.isFinite(n) || n <= 0) return '—';
  const date = new Date(n / 1000);
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    ...opts,
  });
}

/** Relative time from microsecond epoch ("3 分鐘前"); falls back to absolute beyond 7 days. */
export function formatRelativeUs(us: number | string | null | undefined): string {
  if (us === null || us === undefined || us === '') return '—';
  const n = typeof us === 'string' ? Number(us) : us;
  if (!Number.isFinite(n) || n <= 0) return '—';
  const diffMs = Date.now() - n / 1000;
  const abs = Math.abs(diffMs);
  const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });
  if (abs < 60_000) return rtf.format(-Math.round(diffMs / 1000), 'second');
  if (abs < 3_600_000) return rtf.format(-Math.round(diffMs / 60_000), 'minute');
  if (abs < 86_400_000) return rtf.format(-Math.round(diffMs / 3_600_000), 'hour');
  if (abs < 7 * 86_400_000) return rtf.format(-Math.round(diffMs / 86_400_000), 'day');
  return formatTimestampUs(n, { second: undefined });
}

/** Truncate a long opaque id for table cells, keeping head+tail ("u-apac-01KT…ZXFA"). */
export function shortId(id: string | null | undefined, head = 10, tail = 4): string {
  if (!id) return '—';
  if (id.length <= head + tail + 1) return id;
  return `${id.slice(0, head)}…${id.slice(-tail)}`;
}
